import * as types from "../actions/types";



const initialState = {
  listPublications: null,
  total: 0,
  singlePublication: null,
  publicationsSubject: [],
  publicationForms: [],
  authorsToAdd: [],
  publicationFiles: [],
  loading: false
};


export default function publications(state = initialState, action) {
  switch (action.type) {
    case types.SET_PUBLICATIONS_LIST:
      return {
        ...state,
        listPublications: action.payload.items,
        total: action.payload.total
      };
    case types.SET_SINGLE_PUBLICATION:
      return {
        ...state,
        singlePublication: action.payload
      };
    case types.SET_PUBLICATIONS_SUBJECT:
      return {
        ...state,
        publicationsSubject: action.payload
      };
    case types.SET_PUBLICATIONS_FORMS:
      return {
        ...state,
        publicationForms: action.payload
      };
    case types.SET_PUBLICATIONS_ADD_AUTHOR:
      return {
        ...state,
        authorsToAdd: action.payload
      };
    case types.SET_PUBLICATION_FILES:
      return {
        ...state,
        publicationFiles: action.payload
      };
    case types.SET_PUBLICATIONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}